import {
  AccountsQuery,
  ClustersQuery,
  Conditional,
  generateFormValues,
  NHopsFromAccountQuery,
  QueryType,
  sanitizePayload,
} from 'dashboard/models/graph-query';
import { ApiModel, ApiResource } from 'lib/interfaces/api';
import { Iso8601DateTimeString } from 'lib/types';

export enum GraphQueryTemplateStatus {
  Active = 'active',
  Archived = 'archived',
}

export type InputSchema = Record<string, string>;

// Technically a token, prefixed with "gqt".
export type GraphQueryTemplateId = string;

type TemplatableQueryType = AccountsQuery | ClustersQuery | NHopsFromAccountQuery;

export interface GraphQueryTemplateAttributes<
  T extends TemplatableQueryType = TemplatableQueryType,
> {
  description: string;
  'environment-id': string;
  'input-schema': InputSchema;
  'updated-at': Iso8601DateTimeString;
  name: string;
  payload: T;
  status: GraphQueryTemplateStatus;
  type: QueryType;
}

export interface GraphQueryTemplateRelationships {}

export type GraphQueryTemplate<T extends TemplatableQueryType = TemplatableQueryType> = ApiResource<
  GraphQueryTemplateAttributes<T>,
  GraphQueryTemplateRelationships,
  ApiModel.GraphQueryTemplate
>;

export function graphQueryTemplateToFormValues(
  graphQueryTemplate: GraphQueryTemplate,
): Record<string, Conditional> {
  return generateFormValues(
    graphQueryTemplate.attributes.type,
    graphQueryTemplate.attributes.payload.conditionals,
  );
}

export function sanitizeGraphQueryTemplate(
  graphQueryTemplate: GraphQueryTemplate,
): GraphQueryTemplate {
  return {
    ...graphQueryTemplate,
    attributes: {
      ...graphQueryTemplate.attributes,
      payload: sanitizePayload(graphQueryTemplate.attributes.payload) as TemplatableQueryType,
    },
  };
}

// graph query params expect the type to be within the payload
export function graphQueryParamsFromGraphQueryTemplate(graphQueryTemplate: GraphQueryTemplate) {
  return Object.assign(
    { type: graphQueryTemplate.attributes.type },
    graphQueryTemplate.attributes.payload,
  );
}
